import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { homeInfoHandlers, homeInfoInitialState, homeInfoReducer } from '../reducers/HomeInfoReducer';
import { DatabaseContext } from './DatabaseContext';
import { useHomeInfo } from './useHelpers/useHomeInfo';


/** gets the data for the uiItem.
 * @returns viewListData, confirmation */
export const HomeInfoContext = createContext();

/** gets the data for the uiItem.
 * @returns viewListData,  
 * @returns confirmation*/
const HomeInfoProvider = (props) => {

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // homeInfoInitialState
  const initState = homeInfoInitialState({ database_fns })
  const [homeInfo_state, dispatch] = useReducer(homeInfoReducer, initState);
  const homeInfo_handlers = homeInfoHandlers(dispatch)

  const homeInfo = useHomeInfo()

  useEffect(
    () => {
      homeInfo_handlers.handleSet_clients(homeInfo?.clients)
    },
    // eslint-disable-next-line
    [homeInfo]
  )

  const context = () => <HomeInfoContext.Provider value={{ homeInfo_state, homeInfo_handlers }}>
    {props.children}
  </HomeInfoContext.Provider>

  return context()
}

export default HomeInfoProvider